import { Field } from "formik";
import { Box, FormControl, FormLabel, FormHelperText, Input, FormErrorMessage, Flex } from "@chakra-ui/react";

export const InputField = ({name, label, placeholder, helperMessage, isRequired, ...rest}) => {
	return (
		<Field name={name} isRequired={isRequired}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[name] && form.touched[name]} mb="0.5em" isRequired={isRequired}>
          <Flex justifyContent="center">
            <FormLabel flexGrow={1} fontSize="0.9em">{label}</FormLabel>
            <Box maxWidth="50%" minWidth="50%" flexGrow={1}>
              <Input {...field} {...rest} variant="outline" placeholder={placeholder} />
              {!form.errors[name] && helperMessage && (
                <FormHelperText mt="5px" color="blackAlpha.600" fontSize="0.8em">{helperMessage}</FormHelperText>)
              }
            </Box>
          </Flex>
          <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
	);
};

